import Dispatcher from '../dispatcher';
import POSTCODE_CONSTANTS from '../constants/postcode';
import API from '../../API/api';
import { getMap } from '../helper/gmap';
import { getTranslatedText } from '../helper/get_translated_text';
import MapActions from './map_actions';
import { setValue } from '../../utilities/local_storage';

export const updatePostcodeAction = postcode => Dispatcher.handlePostcodeAction({
    type: POSTCODE_CONSTANTS.UPDATE_POSTCODE_ACTION,
    payload: postcode,
});

export const applyPostcodeAction = postcode => Dispatcher.handlePostcodeAction({
    type: POSTCODE_CONSTANTS.APPLY_POSTCODE_ACTION,
    payload: postcode,
});

export const onChangePostcodeAction = payload => Dispatcher.handlePostcodeAction({
    type: POSTCODE_CONSTANTS.ON_CHANGE_POSTCODE_ACTION,
    payload,
});

export const postcodeInvalidAction = invalidMessage => Dispatcher.handlePostcodeAction({
    type: POSTCODE_CONSTANTS.POSTCODE_INVALID_ACTION,
    payload: invalidMessage || getTranslatedText('form-error-invalid-postcode'),
});

export const postcodeValidAction = () => Dispatcher.handlePostcodeAction({
    type: POSTCODE_CONSTANTS.POSTCODE_VALID_ACTION,
});

export const postcodeExistsButNeedsToBeLoaded = () => Dispatcher.handlePostcodeAction({
    type: POSTCODE_CONSTANTS.POSTCODE_EXISTS_BUT_NEEDS_TO_BE_LOADED_ACTION,
});

export const setPostcodeSuggestion = payload => Dispatcher.handlePostcodeAction({
    type: POSTCODE_CONSTANTS.SET_POSTCODE_SUGGESTION,
    payload
});
